import { useMutation, useQuery } from '@tanstack/react-query'
import { instance } from '../instance'

export const useFetchAllAdminUsers = (filters: Filters) => {
  const fetchAllAdminUsers = async (): Promise<FetchAdminUserResponse> => {
    const response = await instance.get(
      `/admin-dashboard/user-and-invites?searchTerm=${filters.searchTerm}&pageNumber=${filters.pageNumber}&pageSize=${filters.pageSize}`,
    )
    return response.data
  }
  const queryApi = useQuery({
    queryKey: ['fetch all Admin', filters],
    queryFn: fetchAllAdminUsers,
  })
  return queryApi
}
export const useDownloadAdminUsers = (filters: Filters) => {
  const fetchAllAdminUsers = async () => {
    const response = await instance.get(
      `/admin-dashboard/user-and-invites?searchTerm=${filters.searchTerm}&pageNumber=${filters.pageNumber}&pageSize=${filters.pageSize}&download=true`,
      {
        responseType: 'blob',
      },
    )
    return response.data
  }
  const mutateApi = useMutation({
    mutationKey: ['download all Admin', filters],
    mutationFn: fetchAllAdminUsers,
  })
  return mutateApi
}

export const useCreateNewAdminUser = () => {
  const createNewAdmin = async (
    payload: CreateAdminPayload,
  ): Promise<CreateAdminResponse> => {
    const response = await instance.post(
      `/admin-dashboard/create-admin`,
      payload,
    )
    return response.data
  }
  const mutateAPI = useMutation({
    mutationKey: ['Create new admin'],
    mutationFn: (payload: CreateAdminPayload) => createNewAdmin(payload),
  })
  return mutateAPI
}
